import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  actionsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  }
}));

export default useStyles;
